import * as React from 'react'

function SvgSe(props) {
	return (
		<svg viewBox="0 0 16 10" width="1em" height="1em" {...props}>
			<path fill="#006aa7" d="M0 0h16v10H0z" />
			<path fill="#fecc00" d="M5 0h2v10H5z" />
			<path fill="#fecc00" d="M0 4h16v2H0z" />
		</svg>
	)
}

export default SvgSe
